<template>
  <div class="pc-article">
    <div class="pc-article__body">
      <h3>Bedruckbarer Artikel</h3>
    </div>
    <div class="pc-article__parent">
      <div>
        <img v-if="hasImage" :src="previewImage" alt="" class="pc-article__image">
      </div>
      <div class="pc-article__body">
        <span class="pc-article__title">{{ name }}</span>
        <article>{{ description }}</article>
      </div>
    </div>
    <div class="pc-article__body">
      <hr>
      <h4 class="border--b-0">Druckkonfiguration</h4>
      <table class="table">
        <thead>
        <th>{{ $t('configurator.tables.columns.surface') }}</th>
        <th>{{ $t('configurator.tables.columns.print_article') }}</th>
        <th>{{ $t('configurator.tables.columns.graphic_file') }}</th>
        </thead>
        <tbody>
        <template v-for="groupIndex in count" :key="groupIndex">
          <print-job-article-group
                  :index="groupIndex"
                  :article="article"
                  :print-job-configurations="printJobConfigurations"
                  @show="showArticleModal">
          </print-job-article-group>
        </template>
        </tbody>
      </table>
    </div>
  </div>
  <article-modal v-if="articleModalActive"
                 :article="selectedArticle"
                 @close="hideArticleModal">
  </article-modal>
</template>

<script setup>
import {computed, ref} from 'vue'
import {useMainStore} from '@/store'

const store = useMainStore()
// define props
const props = defineProps({
  printJobConfigurations: {
    type: Array,
    required: true
  },
  article: {
    type: Object,
    required: true
  }
})
// define reactive props
const articleModalActive = ref(false)
const selectedArticle = ref(null)
// define computed props
const locale = computed(() => store.settings.locale)

const inEnglish = computed(() => {
  return locale.value === 'en'
})

const requestArticle = computed(() => {
  return props.article.article
})

const baseArticle = computed(() => {
  return props.article.article
})

const hasImage = computed(() => {
  return baseArticle.value.images.length > 0
})

const previewImage = computed(() => {
  if (!hasImage.value) {
    // TODO: add fallback image
    return ''
  }

  return '/images/articles/' + baseArticle.value.images[0].path;
})

const name = computed(() => {
  return (inEnglish.value) ? baseArticle.value.name_en : baseArticle.value.name
})

const description = computed(() => {
  return (inEnglish.value) ? baseArticle.value.description_en : baseArticle.value.description
})

const count = computed(() => {
  return parseInt(props.article.amount)
})
// define methods
const showArticleModal = (article) => {
  selectedArticle.value = article.article
  articleModalActive.value = true
}

const hideArticleModal = () => {
  articleModalActive.value = false
  selectedArticle.value = null
}
</script>